import StatusPill from '../ui/StatusPill';

// Delegates to the shared StatusPill status→color map (design system v3).
export default function TicketStatusBadge({ status }) {
  return <StatusPill status={status} />;
}
